// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  background: white;
}

swiper-slide {
  height: 112px;
  position: relative;
  left: 60px;
}
@media (max-width: 992px) {
  swiper-slide {
    left: -15px;
    height: 80px;
  }
}

.line-dotted-block {
  min-width: 20px;
  height: 63px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .line-dotted-block {
    height: 112px;
    min-width: 50px;
  }
  .line-dotted-block ion-img {
    width: 23px;
  }
}

.category-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
  height: 100%;
}
@media (min-width: 991px) {
  .category-wrapper {
    min-width: -moz-fit-content;
    min-width: fit-content;
  }
}
.category-wrapper .category-name {
  padding-top: 10px;
  font-size: 12px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0px;
  font-weight: 100;
  margin-bottom: 0px;
  width: 60px;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: #979797;
}
@media (min-width: 991px) {
  .category-wrapper .category-name {
    width: 100px;
    font-size: 22px;
  }
  .category-wrapper .category-name.selected {
    color: var(--text-color);
    transition: ease-in-out 0.5s;
  }
}
.category-wrapper.selected {
  transition: 200ms linear;
}
.category-wrapper ion-chip {
  opacity: 1;
  border-radius: 50%;
  padding: 5px;
  background: white;
  text-transform: capitalize;
  flex: 0 0 auto;
  height: 60px;
  width: 60px;
  margin: 0px;
  padding: 0px;
  position: relative;
}
@media (min-width: 991px) {
  .category-wrapper ion-chip {
    height: 60px;
    width: 60px;
  }
}
.category-wrapper ion-chip .category-image {
  width: 80%;
  margin: 0 auto;
}
.category-wrapper ion-chip .border-dotted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 58px;
  height: 58px;
  background: url("/assets/losteria/border-dotted_black.svg") no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .category-wrapper ion-chip .border-dotted {
    height: 55px;
    width: 55px;
  }
}

@media (max-width: 992px) {
  .swiper-slide-active {
    width: 100px !important;
  }
}
.swiper-slide-active ion-chip {
  opacity: 1;
  background: var(--ion-color-primary);
  height: 80px;
  width: 80px;
}
@media (min-width: 991px) {
  .swiper-slide-active ion-chip {
    width: 70px;
    height: 70px;
  }
}
.swiper-slide-active ion-chip ion-img {
  filter: contrast(1.2) invert(1);
}
.swiper-slide-active ion-chip .border-dotted {
  width: 78px;
  height: 78px;
}
@media (min-width: 991px) {
  .swiper-slide-active ion-chip .border-dotted {
    width: 65px;
    height: 65px;
  }
}
.swiper-slide-active .border-dotted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 58px;
  height: 58px;
  background: url("/assets/losteria/border-dotted.svg") no-repeat center center/100% 100% !important;
}
@media (min-width: 991px) {
  .swiper-slide-active .border-dotted {
    height: 55px;
    width: 55px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/scrolling-categoris/scrolling-categories.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;AADD;;AAIA;EACC,aAAA;EACA,kBAAA;EACA,UAAA;AADD;ACDE;EDDF;IAKE,WAAA;IACA,YAAA;EACA;AACF;;AACA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAED;ACrBE;EDcF;IAOE,aAAA;IACA,eAAA;EAIA;EAHA;IACC,WAAA;EAKD;AACF;;AAFA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,YAAA;AAKD;ACtCE;ED4BF;IAOE,2BAAA;IAAA,sBAAA;EAOA;AACF;AANC;EACC,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;AAQF;AC5DE;EDqCD;IAiBE,YAAA;IACA,eAAA;EAUD;EATC;IACC,wBAAA;IACA,4BAAA;EAWF;AACF;AADC;EACC,wBAAA;AAGF;AACC;EACC,UAAA;EAEA,kBAAA;EACA,YAAA;EACA,iBAAA;EAGA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAFF;ACtFE;ED0ED;IAiBE,YAAA;IACA,WAAA;EADD;AACF;AAEE;EACC,UAAA;EACA,cAAA;AAAH;AAEE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,6FAAA;AAAH;ACzGE;EDkGA;IASE,YAAA;IACA,WAAA;EAEF;AACF;;ACzGE;ED2GF;IAEE,uBAAA;EACA;AACF;AACC;EACC,UAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;AACF;AC3HE;EDsHD;IAME,WAAA;IACA,YAAA;EAGD;AACF;AAFE;EACC,+BAAA;AAIH;AAFE;EACC,WAAA;EACA,YAAA;AAIH;ACxIE;EDkIA;IAIE,WAAA;IACA,YAAA;EAMF;AACF;AAHC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kGAAA;AAKF;ACvJE;ED2ID;IASE,YAAA;IACA,WAAA;EAOD;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tbackground: white;\n}\n\nswiper-slide {\n\theight: 112px;\n\tposition: relative;\n\tleft: 60px;\n\t@include mobile {\n\t\tleft: -15px;\n\t\theight: 80px;\n\t}\n}\n.line-dotted-block {\n\tmin-width: 20px;\n\theight: 63px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t@include desktop {\n\t\theight: 112px;\n\t\tmin-width: 50px;\n\t\tion-img {\n\t\t\twidth: 23px;\n\t\t}\n\t}\n}\n.category-wrapper {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tmin-width: fit-content;\n\theight: 100%;\n\t@include desktop {\n\t\tmin-width: fit-content;\n\t}\n\t.category-name {\n\t\tpadding-top: 10px;\n\t\tfont-size: 12px;\n\t\tword-break: break-word;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tmargin-top: 0px;\n\t\tfont-weight: 100;\n\t\tmargin-bottom: 0px;\n\t\twidth: 60px;\n\t\ttext-align: center;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tcolor: #979797;\n\t\t@include desktop {\n\t\t\twidth: 100px;\n\t\t\tfont-size: 22px;\n\t\t\t&.selected {\n\t\t\t\tcolor: var(--text-color);\n\t\t\t\ttransition: ease-in-out 0.5s;\n\t\t\t}\n\t\t}\n\t}\n\t// &:first-child {\n\t// \tmargin-left: 12px;\n\t// }\n\n\t// &:last-child {\n\t// \tmin-width: 100% !important;\n\t// }\n\t&.selected {\n\t\ttransition: 200ms linear;\n\t\t\n\t}\n\n\tion-chip {\n\t\topacity: 1;\n\n\t\tborder-radius: 50%;\n\t\tpadding: 5px;\n\t\tbackground: white;\n\n\t\t// transition: color 200ms linear, background 200ms linear;\n\t\ttext-transform: capitalize;\n\t\tflex: 0 0 auto;\n\t\theight: 60px;\n\t\twidth: 60px;\n\t\tmargin: 0px;\n\t\tpadding: 0px;\n\t\tposition: relative;\n\n\t\t@include desktop {\n\t\t\theight: 60px;\n\t\t\twidth: 60px;\n\t\t}\n\t\t.category-image {\n\t\t\twidth: 80%;\n\t\t\tmargin: 0 auto;\n\t\t}\n\t\t.border-dotted {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\twidth: 58px;\n\t\t\theight: 58px;\n\t\t\tbackground: url('/assets/losteria/border-dotted_black.svg') no-repeat center center/ 100% 100%;\n\t\t\t@include desktop {\n\t\t\t\theight: 55px;\n\t\t\t\twidth: 55px;\n\t\t\t}\n\t\t}\n\t}\n}\n.swiper-slide-active {\n\t@include mobile {\n\t\twidth: 100px !important;\n\n\t}\n\tion-chip {\n\t\topacity: 1;\n\t\tbackground: var(--ion-color-primary);\n\t\theight: 80px;\n\t\twidth: 80px;\n\t\t@include desktop {\n\t\t\twidth: 70px;\n\t\t\theight: 70px;\n\t\t}\n\t\tion-img {\n\t\t\tfilter: contrast(1.2) invert(1);;\n\t\t}\n\t\t.border-dotted {\n\t\t\twidth: 78px;\n\t\t\theight: 78px;\n\t\t\t@include desktop {\n\t\t\t\twidth: 65px;\n\t\t\t\theight: 65px;\n\t\t\t}\n\t\t}\n\t}\n\t.border-dotted {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 58px;\n\t\theight: 58px;\n\t\tbackground: url('/assets/losteria/border-dotted.svg') no-repeat center center/ 100% 100% !important;\n\t\t@include desktop {\n\t\t\theight: 55px;\n\t\t\twidth: 55px;\n\t\t}\n\t}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
